module.exports = __webpack_public_path__ + "images/dashboard-progress-no-color@2x-b4c01ee6b140eceae6f09ca2c33caa62.png";